import React from 'react'
import {Button} from "antd";
import { navigate } from '@reach/router';

const PurchaseCardExtra = () => {

    const openCreate = () => navigate('purchase/create');

    return(
        <React.Fragment>
            <Button
                type={'primary'}
                onClick={openCreate}
            >
                Yeni Ekle
            </Button>
        </React.Fragment>
    )

}
export default PurchaseCardExtra